import { Skeleton } from '@/components/ui/skeleton';
import { Switch } from '@/components/ui/switch';
import { Typography } from '@/components/ui/typography';

export interface SettingItemProps {
  title: React.ReactNode;
  description: React.ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export function SettingItem({
  title,
  description,
  checked,
  onCheckedChange,
  disabled = false,
  isLoading = false,
}: SettingItemProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex flex-1 flex-col gap-1">
        <Typography variant="body2" as="h3">
          {title}
        </Typography>
        <Typography variant="body1" className="!text-fx-neutral-600">
          {description}
        </Typography>
      </div>
      {isLoading ? (
        <Skeleton className="h-4 w-8 !rounded-full" />
      ) : (
        <Switch
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled}
        />
      )}
    </div>
  );
}
